export default "__VITE_ASSET__DkqUNnaE__"